import { useEffect, useState } from "react";
import { jsPDF } from "jspdf";

import useHistoricoAtendimento from "../../hooks/useHistoricoAtendimento";

const Realizados = () => {
  const { historico, carregarHistorico } = useHistoricoAtendimento();
  const hoje = new Date().toISOString().split("T")[0];
  const [dataInicial, setDataInicial] = useState(hoje);
  const [dataFinal, setDataFinal] = useState(hoje);
  // Estado para o modal de detalhes
  const [atendimentoSelecionado, setAtendimentoSelecionado] = useState(null);

  // =========================
  // CARREGAMENTO INICIAL
  // =========================
  useEffect(() => {
    carregarHistorico();
  }, [carregarHistorico]);

  // =========================
  // PESQUISAR
  // =========================
  const pesquisar = () => {
    carregarHistorico(dataInicial, dataFinal);
  };

  // =========================
  // GERAR PDF DO ATENDIMENTO
  // =========================
  const gerarPDF = (atendimento) => {
    if (!atendimento) return;

    const doc = new jsPDF();
    const cliente = atendimento.cliente;
    const advogado = atendimento.advogado;

    // ---------------------------------------------------------
    // CABEÇALHO (Estilo TIMBRADO)
    // ---------------------------------------------------------
    const corDestaque = [128, 40, 40];

    // 1. Nome Central/Esquerda
    doc.setFont("times", "bold");
    doc.setFontSize(13);
    doc.setTextColor(0, 0, 0);
    doc.text("Rayane Cristina", 135, 20, { align: "right" });

    doc.setFont("times", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text("Rodrigues Pessoa Gomes", 135, 25, { align: "right" });

    // 2. Linha Divisória Vertical
    doc.setDrawColor(...corDestaque);
    doc.setLineWidth(0.8);
    doc.line(140, 15, 140, 30);

    // 3. Informações da Advogada / OAB
    doc.setFont("times", "bold");
    doc.setFontSize(9);
    doc.setTextColor(...corDestaque);
    doc.text("ADVOGADA", 143, 19);
    doc.text("OAB/PA  27.956", 143, 24);
    doc.text("OAB/MA 23.002-A", 143, 29);

    // 4. Linha Horizontal Inferior do Cabeçalho
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(1.2);
    doc.line(20, 34, 190, 34);

    // ---------------------------------------------------------
    // CORPO DO DOCUMENTO
    // ---------------------------------------------------------
    doc.setFont("times", "bold");
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("FICHA DE ATENDIMENTO", 105, 45, { align: "center" });

    // Informações Básicas
    doc.setFontSize(11);
    doc.text(`Cliente: ${cliente?.nomeCliente || "N/A"}`, 20, 57);

    doc.setFont("times", "normal");
    const nomeAdvogado =
      advogado?.nome || (typeof advogado === "string" ? advogado : "Não informado");
    doc.text(`Atendido por: ${nomeAdvogado}`, 20, 64);

    const dataAtendimento = atendimento.updatedAt
      ? new Date(atendimento.updatedAt).toLocaleDateString("pt-BR")
      : new Date().toLocaleDateString("pt-BR");
    doc.text(`Data: ${dataAtendimento}`, 20, 71);

    // Assunto
    doc.setFont("times", "bold");
    doc.text("Assunto:", 20, 83);
    doc.setFont("times", "normal");
    doc.text(atendimento.assunto || "Não informado", 40, 83);

    // Descrição
    doc.setFont("times", "bold");
    doc.text("Descrição do Atendimento:", 20, 95);

    doc.setFont("times", "normal");
    doc.text(atendimento.descricao || "Sem descrição registrada.", 20, 102, {
      maxWidth: 170,
    });

    // Salvar PDF
    doc.save(`Ficha_${cliente?.nomeCliente || "Atendimento"}.pdf`);
  };

  return (
    <div className="container-consulta-processos">
      <div className="card">
        <h1>ATENDIMENTOS REALIZADOS</h1>

        {/* =========================
            FILTROS
        ========================= */}
        <div
          className="search-bar"
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <input
            type="date"
            value={dataInicial}
            onChange={(e) => setDataInicial(e.target.value)}
          />

          <input
            type="date"
            value={dataFinal}
            onChange={(e) => setDataFinal(e.target.value)}
          />

          <button onClick={pesquisar}>Pesquisar</button>
        </div>

        {/* =========================
            TABELA
        ========================= */}
        <table className="table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Assunto</th>
              <th>Status</th>
              <th>Check-in</th>
              <th>Finalizado</th>
              <th>Etapa seguinte</th>
            </tr>
          </thead>

          <tbody>
            {historico.map((item) => (
              <tr
                key={item._id}
                onClick={() => setAtendimentoSelecionado(item)}
                style={{ cursor: "pointer" }}
                title="Clique para ver os detalhes"
              >
                <td>{item.cliente?.nomeCliente || "Cliente não informado"}</td>
                <td>{item.assunto || "-"}</td>
                <td>{item.status}</td>
                <td>{new Date(item.createdAt).toLocaleString()}</td>
                <td>{new Date(item.updatedAt).toLocaleString()}</td>
                <td>{item.proximoPasso}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* =========================
          MODAL DE DETALHES DO ATENDIMENTO
      ========================= */}
      {atendimentoSelecionado && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              width: "90%",
              maxWidth: "680px",
              maxHeight: "90vh",
              overflowY: "auto",
              borderRadius: "8px",
              padding: "24px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
          >
            {/* CABEÇALHO DO MODAL (SIMILARE AO TIMBRADO DO PDF) */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "2px solid #000",
                paddingBottom: "12px",
                marginBottom: "20px",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#802828",
                  }}
                >
                  FICHA DE ATENDIMENTO
                </h3>
              </div>

              <div
                style={{
                  textAlign: "right",
                  borderLeft: "2px solid #802828",
                  paddingLeft: "12px",
                }}
              >
                <div style={{ fontWeight: "bold", fontSize: "13px" }}>
                  Rayane Cristina
                </div>
                <div style={{ fontSize: "11px", color: "#555" }}>
                  Rodrigues Pessoa Gomes
                </div>
                <div
                  style={{
                    fontSize: "10px",
                    color: "#802828",
                    fontWeight: "bold",
                    marginTop: "2px",
                  }}
                >
                  ADVOGADA | OAB/PA 27.956 | OAB/MA 23.002-A
                </div>
              </div>
            </div>

            {/* CORPO DO ATENDIMENTO */}
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div>
                <strong>Cliente:</strong>{" "}
                {atendimentoSelecionado.cliente?.nomeCliente || "N/A"}
              </div>

              <div>
                <strong>Atendido por:</strong>{" "}
                {atendimentoSelecionado.advogado?.nome ||
                  (typeof atendimentoSelecionado.advogado === "string"
                    ? atendimentoSelecionado.advogado
                    : "Não informado")}
              </div>

              <div>
                <strong>Data de Finalização:</strong>{" "}
                {new Date(atendimentoSelecionado.updatedAt).toLocaleString("pt-BR")}
              </div>

              <div>
                <strong>Assunto:</strong>
                <p
                  style={{
                    margin: "4px 0 0 0",
                    padding: "8px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                >
                  {atendimentoSelecionado.assunto || "Não informado"}
                </p>
              </div>

              <div>
                <strong>Descrição do Atendimento:</strong>
                <p
                  style={{
                    margin: "4px 0 0 0",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #eee",
                    borderRadius: "4px",
                    whiteSpace: "pre-wrap",
                    minHeight: "80px",
                  }}
                >
                  {atendimentoSelecionado.descricao || "Sem descrição registrada."}
                </p>
              </div>
            </div>

            {/* BOTÕES DO RODAPÉ DO MODAL */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "24px",
                paddingTop: "12px",
                borderTop: "1px solid #ddd",
              }}
            >
              <button
                onClick={() => gerarPDF(atendimentoSelecionado)}
                style={{
                  backgroundColor: "#802828",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                Baixar PDF
              </button>

              <button
                onClick={() => setAtendimentoSelecionado(null)}
                style={{
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Realizados;